import { render } from "./LearnerInfo.vue?vue&type=template&id=4e9f1973"
import script from "./LearnerInfo.vue?vue&type=script&lang=js"
export * from "./LearnerInfo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__